<template>
    <div class="continer">
        <background>
            <template v-if="!isShowBlankPage">
                <div class="info">
                    <div class="image-list" >
                        <template  v-for="(imageGroup, index) in imgShowList" >
                            <div class="image-block" v-for="(item) in imageGroup" :key="item.imgIndex" @click="previewImage(item.imgIndex)">
                                <div class="index-text">{{index+1}}{{item.type}}</div>
                                <el-checkbox 
                                    v-if="isScanFinish"
                                    class="check-box"
                                    v-model="item.checked"
                                    @change="(e) => {handleSelectChange(e,item)}"
                                    @click.stop.native="() =>{}"></el-checkbox>
                                <el-image
                                    style="width: 100%; height: 100%"
                                    :style="{transform: `rotate(${item.rotation || 0}deg)`}"
                                    :src="item.url"
                                    fit="contain">
                                </el-image>
                            </div>
                        </template>
                    </div>
                </div>
                <div v-if="isScanFinish" class="footer-btn">
                    <div class="cancle-button" @click="backPage">继续扫描</div>
                    <div v-if="batchDelImageList.length" class="cancle-button" @click="handleBatchDelImage">批量删除</div>
                    <div class="main-button" @click="nextStep">开始制单</div>
                </div>
            </template>
            <template v-else>
                <div class="info">
                    <div class="image-list" >
                        <div class="image-block" v-for="(item, index) in blankImageList" :key="index" @click="previewImage(index)">
                            <el-image
                                style="width: 100%; height: 100%"
                                :src="item.url"
                                fit="contain">
                            </el-image>
                        </div>
                    </div>
                </div>
                <div class="footer-btn">
                    <div class="cancle-button" @click="backImagePage">返回上一步</div>
                </div>
            </template>   
        </background>
        <pageHeader :isCustom="!isScanFinish"></pageHeader>
        <!-- 空白页提示 -->
        <div v-if="blankPageTipsVisible" class="check-blank-tips" @click="checkBlankPage">
            检测到空白页数量： {{blankImageList.length}}
            <span>点击查看 <i class="el-icon-d-arrow-right"></i></span>
        </div>
        <!-- 扫描结束弹窗 -->
        <el-dialog
            :visible.sync="dialogVisible"
            top="40vh"
            width="800px"
            :show-close="false">
            <div class="confirm-content">
                <div class="info">
                   <img src="@/assets/images/busImage/confirm.png"/>
                   <div class="tips">扫描完成</div>
                </div>
            </div>
        </el-dialog>
        <previewDialog ref="previewDialog" @delImage="delImage" @rotationImage="rotationImage" @addOrigin="addOrigin"></previewDialog>
        <tipsDialog tipsMessage="扫描中，请稍等..."
                     :dialogVisible="scanLoadingDialogVisible">
        </tipsDialog>
        <tipsDialog tipsMessage="等待扫描仪复位中，请稍等..."
                    :dialogVisible="waitScannerLocationDialogVisible">
        </tipsDialog>
        <tipsDialog tipsMessage="扫描仪入口处无纸，或纸张放置不正确，请处理后再扫描"
                     :dialogVisible="noPaperDialogVisible">
                    <div class="btn-group">
                        <div class="cancle-btn" @click="endScan">结束扫描</div>
                        <div class="confirm-btn" @click="handleErrNoPaper">已处理</div>
                    </div>
        </tipsDialog>
        <tipsDialog tipsMessage="扫描仪盖未关闭，请处理后再扫描"
                     :dialogVisible="openlidDialogVisible">
                    <div class="text-btn" @click="openScanner">打开扫描仪</div>
        </tipsDialog>
        <tipsDialog tipsMessage="出现卡纸，清除卡纸后请将扫描仪推回设备内，并取出已扫描的原始凭证"
                     :dialogVisible="paperJamDialogVisible">
                     <div class="text-btn" @click="openScanner">打开扫描仪</div>
        </tipsDialog>
        <tipsDialog tipsMessage="排纸单元出现卡纸，清除卡纸后请将扫描仪推回设备内，并取出已扫描的原始凭证"
                     :dialogVisible="paperLayoutDialogVisible">
                     <div class="text-btn" @click="openScanner">打开扫描仪</div>
        </tipsDialog>
        <tipsDialog tipsMessage="请点击打开托盘，取出原始凭证"
                     :dialogVisible="ejectFileDialogVisible">
                     <div class="text-btn" @click="openDish">打开托盘</div>
        </tipsDialog>
        <tipsDialog :tipsMessage="continueTips"
                     :dialogVisible="continueScanDialogVisible">
                     <div class="btn-group">
                        <div class="confirm-btn" @click="orderExit">整单退出</div>
                        <div class="cancle-btn-mini" @click="continueScan">继续扫描</div>
                    </div>
        </tipsDialog>
        <exitTicketProcess ref="exitTicketProcess" exitTitle="取出全部原始凭证后，请点击收回托盘" @dishHaveNoPaper="dishHaveNoPaper" @dishHandleFinish="dishHandleFinish"></exitTicketProcess>
        <tipsDialog tipsMessage="扫描中，暂不可预览" :dialogVisible="notPreviewDialogVisible"></tipsDialog>
        <!-- 图片未上传完成或错误 -->
        <tipsDialog :tipsMessage="notUploadTips" :dialogVisible="notUploadDialogVisible"></tipsDialog>
        <errorDialog :errorMessage="errorMessage" :dialogVisible="errorDialogVisible" @handleClose="handleClose"></errorDialog>             
        <!-- 批量删除 -->
        <tipsDialog :dialogVisible="delTipsDialogVisible" :tipsMessage="`将删除${batchDelImageList.length}张图片，图片删除后将无法恢复，是否继续删除？`" @handleClose="closeTipsDialog">
            <div class="btn-group">
                <div class="cancle-btn" @click="closeTipsDialog">取消</div>
                <div class="confirm-btn" @click="confirmDel">确认</div>
            </div>
        </tipsDialog>          
    </div>
</template>
<script>
import background from '@/components/background'
import pageHeader from '@/components/pageHeader'
import tipsDialog from '@/components/tipsDialog'
import errorDialog from '@/components/errorDialog'
import previewDialog from '@/components/previewDialog'
import exitTicketProcess from '@/components/exitTicketProcess'
import { getToken, getCookie } from "@/utils/auth";
import { createTask,uploadLogs } from '@/api/user';
import { finishUpload,setImgAngle } from '@/api/order'
import axios from "axios";
import paperDishMixin from '@/mixin/paperDishMixin'
import scanMixin from '@/mixin/scanMixin'
let isFromNext = false
export default {
    mixins: [scanMixin,paperDishMixin],
    components: { background,pageHeader,tipsDialog,errorDialog,previewDialog,exitTicketProcess },
    data(){
        return {
            imgShowList: [],
            dialogVisible: false,
            uploadErrImageList: [],
            // 错误提示框
            noPaperDialogVisible: false,
            paperJamDialogVisible: false,
            paperLayoutDialogVisible: false,
            ejectFileDialogVisible: false,
            notPreviewDialogVisible: false,
            notUploadDialogVisible: false,
            notUploadTips: '',
            openlidDialogVisible: false,
            waitScannerLocationDialogVisible: false, // 等待扫描仪复位loading
            continueScanDialogVisible: false, // 卡纸续扫弹窗
            continueTips: '当前扫描已超过20张，您可以选择继续扫描或者整单退出重扫。\n继续扫描前，请仔细确认卡纸纸张是否已扫入终端内。',
            // 未知错误
            errorMessage: '',
            errorDialogVisible: false,
            // 扫描loading
            scanLoadingDialogVisible:false, // 扫描中
            isScanFinish: false, // 是否扫描完成
            //-----空白页预览逻辑-------------
            isShowBlankPage: false, // 是否显示空白页
            blankPageTipsVisible: false, // 是否显示空白页提示
            blankImageList: [],
            // -----批量删除------
            batchDelImageList: [],
            delTipsDialogVisible: false
        }
    },
    mounted(){
        // 开始扫描
        if(!isFromNext){
            this.startScan();
        }else {
            this.isScanFinish = true
        }
        
        // 监听扫描完成一张的回调
        this.ist.addEventListener("onScanPage", this.onScanPageComplete);
        let imgShowList = localStorage.getItem('imgShowList')
        let blankImageList = localStorage.getItem('blankImageList')
        if(imgShowList){
            this.imgShowList = JSON.parse(imgShowList) || []
        }
        if(blankImageList){
            this.blankImageList = JSON.parse(blankImageList) || []
            if(this.blankImageList.length > 0){
                this.openBlankPageTips() 
            }
        }
    },
    destroyed () {
        this.ist.removeEventListener("onScanPage", this.onScanPageComplete);
        this.$emit('HideBts');
    },
    beforeRouteEnter(to, from,next){
        if('orderInfo' === from.name || 'infoAnalysis' === from.name) {
            isFromNext = true
        }else {
            isFromNext = false
        }
        next()
    },
    computed: {
        orgId() {
            if(getCookie('orgInfo')){
                return +(JSON.parse(getCookie('orgInfo')).id)
            }else {
                return 0
            }
        }
    },
    methods: {
        nextStep(){
            this.checkImageUploadStatus('next')
        },
        backPage(){
            this.startScan();
        },
        endScan(){
            if(this.imgShowList.length === 0){
                this.$router.go(-1)
            }else {
                this.noPaperDialogVisible = false
                // 按扫描完成处理
                this.scanLoadingDialogVisible = false
                this.dialogVisible = true
                this.isScanFinish = true
                this.$emit('PlaySound','scanEnd');
                setTimeout(() => {
                    this.dialogVisible = false
                    if(this.blankImageList.length > 0){
                       this.openBlankPageTips() 
                    }
                },1000)
            }
        },
        previewImage(imgIndex){
            if(!this.isScanFinish) {
                this.notPreviewDialogVisible = true
                setTimeout(() => {
                    this.notPreviewDialogVisible = false
                },1000)
                return
            }
            if(this.isShowBlankPage){
                let imgList = JSON.parse(JSON.stringify(this.blankImageList))
                this.$refs.previewDialog.openDialog(imgList,imgIndex,'blank')
            }else {
                let imgList = this.imgShowList.flat(1)
                let curIndex = 0
                for(let i =0; i<imgList.length;i++){
                    if(imgList[i].imgIndex === imgIndex){
                        curIndex = i
                        break 
                    }
                }
                this.$refs.previewDialog.openDialog(imgList,curIndex)
            }
            
        },
        // 检查图片上传情况
        // type: back (返回上一页) next （下一步）
        checkImageUploadStatus(type){
            let imgList = this.imgShowList.flat(1)
            let notHaveId = imgList.filter(item => !item.fileId)
            if(this.uploadErrImageList.length > 0){
                this.notUploadTips = `有${this.uploadErrImageList.length}张图片上传失败，正在重试，请稍后再试或取消重试`
                this.notUploadDialogVisible = true
                setTimeout(() => {
                    this.notUploadDialogVisible = false
                },1000)
                this.uploadErrImageList.forEach(item => {
                    this.uploadImage(item.blob,item.imgIndex,item.imgType,'retry',item.groupId)
                })
            }else if(notHaveId.length > 0){
                this.notUploadTips = `网络较差，有${notHaveId.length}张图片正在上传，请稍后再试或取消重试`
                this.notUploadDialogVisible = true
                setTimeout(() => {
                    this.notUploadDialogVisible = false
                },1500)
            }else {
                localStorage.setItem('imgShowList', JSON.stringify(this.imgShowList));
                localStorage.setItem('blankImageList', JSON.stringify(this.blankImageList));
                if(type === 'back'){
                    this.$router.go(-1)
                }
                if(type === 'next'){
                    let imageData = (this.imgShowList.flat(1)).map(item => item.fileId)
                    finishUpload(imageData).then(res => {
                        if(res.code === 200){
                            this.$router.push({name: 'infoAnalysis'})
                        }
                    })
                }
            }
        },
        uploadImage(blob,imgIndex,imgType,type,groupId) {
            let orgInfo = JSON.parse(getCookie('orgInfo'))
            const formData = new FormData();
            formData.append('file', blob); 
            formData.append('groupId',groupId)
            formData.append('fileName', `${new Date().getTime()}.jpg`)
            formData.append('automatic', 1)
            formData.append('front', imgType === "A")
            formData.append('orgId', orgInfo.id)
            formData.append('index',imgIndex)
            let baseUrl = process.env.NODE_ENV === "production" ? process.env.VUE_APP_BASE_API : '/api'
            let url = baseUrl + "/file/upload"

            if(type === 'retry'){
                this.uploadErrImageList = this.uploadErrImageList.filter(item => item.imgIndex !== imgIndex)
            }

            axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization' : getToken()
                    },
                timeout: 40000    
                })
                .then(res => {
                   if(res.data.code === 200){
                        this.setImageFileId(res.data.data.fileId,imgIndex)
                   }else {
                        let imageInfo = {
                            blob,imgIndex,imgType,type,groupId
                        }
                        this.uploadErrImageList.push(imageInfo)
                        uploadLogs({
                            content: imgIndex,
                            errorCode:-1,
                            module: '图片上传失败'
                        }).catch(e => {})
                   }
                })
                .catch(error => {
                    console.error(error);
                    let imageInfo = {
                        blob,imgIndex,imgType,type,groupId
                    }
                    this.uploadErrImageList.push(imageInfo)
                    uploadLogs({
                        content: imgIndex,
                        errorCode:-1,
                        module: '图片上传失败'
                    }).catch(e => {})
                });
        },
        async setImageFileId(id,imgIndex){
           for(let i = 0; i < this.imgShowList.length; i++ ){
                let group = this.imgShowList[i]
                for(let j = 0;j < group.length; j++){
                    if(imgIndex === group[j].imgIndex){
                        group[j].fileId = id
                        if(group[j].rotation){
                            await setImgAngle({id:id,angle:group[j].rotation})
                        }
                        return 
                    }
                }
           }

        },
        delImage(imgIndex){
            for(let i = 0; i < this.imgShowList.length; i++ ){
                let group = this.imgShowList[i]
                for(let j = 0;j < group.length; j++){
                    if(imgIndex === group[j].imgIndex){
                        group.splice(j,1)
                        return 
                    }
                }
           }
        },
        rotationImage(imgIndex,rotation){
            for(let i = 0; i < this.imgShowList.length; i++ ){
                let group = this.imgShowList[i]
                for(let j = 0;j < group.length; j++){
                    if(imgIndex === group[j].imgIndex){
                        this.$set(group[j],'rotation',rotation)
                        return 
                    }
                }
           }
        },
        // 批量删除选中
        handleSelectChange(e,item){
            if(e){
                this.batchDelImageList.push(item)
            }else {
                this.batchDelImageList = this.batchDelImageList.filter(batchItem => batchItem.imgIndex !== item.imgIndex )
            }
        },
        // 批量删除
        handleBatchDelImage(){
            this.delTipsDialogVisible = true
        },
        closeTipsDialog(){
            this.delTipsDialogVisible = false
            let batchDelImageList = JSON.parse(JSON.stringify(this.batchDelImageList))
            batchDelImageList.forEach(item => {
                for(let i = 0; i < this.imgShowList.length; i++ ){
                    let group = this.imgShowList[i]
                    for(let j = 0;j < group.length; j++){
                        if(item.imgIndex === group[j].imgIndex){
                            group[j].checked = false
                            return 
                        }
                    }
                }
            })
            this.batchDelImageList = []
        },
        confirmDel(){
            let batchDelImageList = JSON.parse(JSON.stringify(this.batchDelImageList))
            batchDelImageList.forEach(item => {
                this.delImage(item.imgIndex)
            })
            this.delTipsDialogVisible = false
            this.batchDelImageList = []
        },
        async addOrigin(index){
            let image = this.blankImageList[index]
            this.blankImageList.splice(index,1)
            let imgBase64 = await this.readFileAsBase64(image.file);
            let imgBolb = this.base64ToBlob('data:image/jpeg;base64,' + imgBase64)
            if(image.type === 'B'){
                this.imgShowList[image.index -1].push(image)
                this.uploadImage(imgBolb,image.imgIndex,image.type,"",image.groupId)
            }else {
                this.imgShowList[image.index -1].unshift(image)
                this.uploadImage(imgBolb,image.imgIndex,image.type,"",image.groupId)
            }
        },
        backImagePage(){
            this.isShowBlankPage = false
            if(this.blankImageList.length > 0){
                this.openBlankPageTips() 
            }
        },
        handleErrNoPaper(key){
            this.noPaperDialogVisible = false
            this.startScan();
        },
        // --------硬件逻辑----------
        startScan() {
            this.scanLoadingDialogVisible = true
            this.scan().then(res => {
                this.scanLoadingDialogVisible = false
                this.dialogVisible = true
                this.isScanFinish = true
                this.$emit('PlaySound','scanEnd');
                setTimeout(() => {
                    this.dialogVisible = false
                    if(this.blankImageList.length > 0){
                       this.openBlankPageTips() 
                    }
                },1000)
            }).catch(e => {
                console.log(e)
                this.scanLoadingDialogVisible = false
                if(e.status === 1){
                    this.noPaperDialogVisible = true
                }else if(e.status === 2){
                    this.paperJamDialogVisible = true
                }else if(e.status === 3){
                    this.openlidDialogVisible = true
                }else if(e.status === 5){
                    this.paperLayoutDialogVisible = true
                }
            })
        },
        openBlankPageTips(){
            this.blankPageTipsVisible = true
        },
        checkBlankPage(){
            this.isShowBlankPage = true
            this.blankPageTipsVisible = false
        },
        // 扫描文件
        async onScanPageComplete(params) {
            let imageGroup = []
            let groupId = new Date().getTime()
            this.scanLoadingDialogVisible = false
            // 正面图像
            let frontImg = {}
            frontImg.imgIndex = new Date().getTime() + '0'
            frontImg.groupId = groupId
            frontImg.type = "A"
            let frontBase64 = await this.readFileAsBase64(params.front_image)
            let frontImgBolb = this.base64ToBlob('data:image/jpeg;base64,' + frontBase64)
            frontImg.url = URL.createObjectURL(frontImgBolb,frontImg.imgIndex)
            frontImg.file = params.front_image
            frontImg.black = params.front_blank_page
            
            //  反面图像   
            let backImg = {};
            backImg.imgIndex = new Date().getTime() + '1';
            backImg.groupId = groupId
            backImg.type = "B"
            let backBase64 = await this.readFileAsBase64(params.back_image);
            let backImgBolb = this.base64ToBlob('data:image/jpeg;base64,' + backBase64)
            backImg.url = URL.createObjectURL(backImgBolb, backImg.imgIndex)
            backImg.file = params.back_image
            backImg.black = params.back_blank_page

            if(!frontImg.black){
                this.uploadImage(frontImgBolb,frontImg.imgIndex,frontImg.type,"",frontImg.groupId)
                imageGroup.push(frontImg)
            }else {
                frontImg.index = this.imgShowList.length +1
                this.blankImageList.push(frontImg)
            }
            if(!backImg.black){
                this.uploadImage(backImgBolb,backImg.imgIndex,backImg.type,"",backImg.groupId)
                imageGroup.push(backImg)
            }else {
                backImg.index = this.imgShowList.length +1
                this.blankImageList.push(backImg)
            }
            this.imgShowList.push(imageGroup); 
        },  
        base64ToBlob(base64){
            let arr = base64.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: mime });
        },
        // 弹出扫描仪
        openScanner(){
            this.unlockScanner().then(res => {
                this.paperJamDialogVisible = false
                this.paperLayoutDialogVisible = false 
            })
        },
        // 处理卡纸续扫问题
        handleContinueScan(){
            if(this.imgShowList.length > 10){
                this.continueScanDialogVisible = true
            }else{
                this.ejectFileDialogVisible = true
            }
        },
        // 继续扫描按钮
        continueScan(){
            this.continueScanDialogVisible = false
            this.startScan()
        },
        // 整单退出按钮
        orderExit(){
            this.continueScanDialogVisible = false
            this.openDish()
        },
        // 弹出托盘
        openDish(){
            this.ejectFileDialogVisible = false
            this.$refs.exitTicketProcess.getDishHavePaper()
        },
        dishHaveNoPaper(){
            createTask().then(res => {
                localStorage.removeItem('imgShowList')
                this.imgShowList = []
                this.$router.go(-1)
            })
        },
        dishHandleFinish(){
            createTask().then(res => {
                localStorage.removeItem('imgShowList')
                localStorage.removeItem('blankImageList')
                this.imgShowList = []
                this.$router.go(-1)
            }).catch(e => {
                this.restoreDishDialogVisible = true
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .continer {
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .info {
        box-sizing: border-box;
        padding: 55px 135px;
        overflow-y: scroll;
        margin-bottom: 20px;
        .image-list {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap:25px;
        }
        .image-block {
            position: relative;
            width: 243px;
            height: 328px;
            background: #FFF7F8;
            border-radius: 6px;
            overflow: hidden;
        }
        .index-text {
            position: absolute;
            z-index: 1;
            top: 10px;
            right: 10px;
            color: #B63933;
            font-size: 16px;
        }
    }
    .info::-webkit-scrollbar {
        width: 0;
    }
    .footer-btn {
        position: absolute;  
        z-index: 100;
        top: calc(100% - 102px);
        left: 50%;
        transform: translate(-50%,-50%);
        display: flex;
        justify-content: center;
        .cancle-button {
            display: inline-block;
            padding: 20px 77px;
            margin-right: 48px;
            background: #FFEEF1;
            border-radius: 8px;
            border: 2px solid #F7636E;
            font-weight: 600;
            font-size: 28px;
            color: #F7636E;
        }
        .main-button {
            display: inline-block;
            background: linear-gradient( 135deg, #C62D2F 0%, #B23B34 100%);
            border-radius: 8px;
            padding: 20px 77px;
            font-weight: 600;
            font-size: 28px;
            color: #FFFFFF;
        }
    }
    .confirm-content {
        .info {
            display: flex;
            flex-direction: row;
            justify-content: center;
            img {
                height: 56px;
                width: 56px;
            }
            .tips {
                margin-left: 12px;
                margin-top: 5px;
                font-weight: 500;
                font-size: 32px;
                color: rgba(0,0,0,0.85);
            }
        }
        
    }
    .check-blank-tips {
        position: absolute;
        z-index: 20;
        top: calc(100% - 180px);
        left: 50px;
        padding: 20px 30px;
        font-weight: bold;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        span {
            color:#F7636E;
            margin-left: 20px;
        }
    }
    .check-box {
        position: absolute;
        z-index: 100;
        top: 10px;
        left: 10px;
        height: 50px;
        width: 50px;
    }
    /deep/ .el-checkbox__inner {
        height: 34px;
        width: 34px;
        font-size: 34px;
    }
    /deep/.el-checkbox__inner:hover {
        border-color: #B23B34;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #B23B34;
        border-color: #B23B34;
    }
    /deep/ .el-checkbox__inner::after {
        height: 19px;
        width: 8px;
        left: 12px;
        border: 2px solid #FFF;
        border-left: 0;
        border-top: 0;
    }

</style>


